import { render } from "./InvoiceView.vue?vue&type=template&id=31a67c88&scoped=true"
import script from "./InvoiceView.vue?vue&type=script&lang=js"
export * from "./InvoiceView.vue?vue&type=script&lang=js"

import "./InvoiceView.vue?vue&type=style&index=0&id=31a67c88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a67c88"]])

export default __exports__